declare const window: any;
export const BASE_ENV = {
  securityBasePath: window.__env.securityBasePath,
  serverBasePath: window.__env.serverBasePath,
  socketBasePath: window.__env.socketBasePath,
  socketSecurityBasePath: window.__env.socketSecurityBasePath,
  useSSL: window.__env.useSSL || false,
  layout: 0,
  dateFormatSystem: 'YYYY-MM-DD',
  dateFormatPresentation: 'DD/MM/YYYY',
  dateFormatHms: 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ',
  dateFormatHmsPresentation: 'DD/MM/YYYY HH:mm:ss',
  timeFormat: 'HH:mm:ss',
  timeout: 20000,
  homePath: 'app',
  delayToastSuccess: 5000,
  delayToastError: 7000,
};
